import React, { Component } from 'react';
import {tryUploadFileForUserInfo} from 'actions/UserActions';

class UploadBtn extends Component {
  state={
    uploading: false,
  }

  finishUpload = () => {
    this.setState({uploading: false});
  }

  handleUploadFile = (e) => {
    this.setState({uploading: true});
    let file = e.target.files[0];
    tryUploadFileForUserInfo(file, this.props.handleFname, this.finishUpload);
  }

  render() {
    let {label} = this.props;
    return (
      <label className="btn btn-primary btn-xs upload-btn" disabled={this.state.uploading}>
        {label}
        <input
          type="file"
          accept=".pdf"
          disabled={this.state.uploading}
          onChange={this.handleUploadFile} />
      </label>
    )
  }
}

export default UploadBtn;



// WEBPACK FOOTER //
// ./src/components/Worker/UploadBtn.js